import v22Schema, {
  MigrationTypes as V22Types,
} from "../client/schemaVersions/v22.js";
import v23Schema, {
  MigrationTypes as V23Types,
} from "../client/schemaVersions/v23.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V22Types, V23Types>(
  v22Schema,
  v23Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
